import { Capacitor } from '@capacitor/core'

/** The ground the status bar sits on: the entrance's dark one, or the app's light one. */
export type StatusBarTone = 'entrance' | 'app'

/** Light text on the entrance, dark text in the app. Native only: the web has no status bar of
 *  ours, and the plugin would answer «not implemented». It comes in with `import()`, so it
 *  weighs nothing on the initial chunk (`npm run size`). */
export async function applyStatusBarTone(tone: StatusBarTone): Promise<void> {
  if (!Capacitor.isNativePlatform()) return
  const { StatusBar, Style } = await import('@capacitor/status-bar')
  // `Style.Dark` is the plugin's word for light text, made for a dark ground.
  await StatusBar.setStyle({ style: tone === 'entrance' ? Style.Dark : Style.Light })
}
